appSocial.controller('leaderCopyPage', [
    '$scope', '$state', '$ionicModal', 'SocialLocaleService', 'SocialUtils', 'trader', 'SocialActionService', 'SocialTypes',
    function ($scope, $state, $ionicModal, SocialLocaleService, SocialUtils, trader, SocialActionService, SocialTypes) {
        class LeaderCopyPage {
            constructor() {
                this.translation = SocialLocaleService.translation;
                this.$scope = $scope;
                this.$state = $state;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                /**
                 * @type {SocialActionService}
                 */
                this.actionService = SocialActionService;

                this.actions = SocialTypes.CopyAction;

                this.trader = trader;
                this.action = $state.params.action || this.actions.StartCopy;

                this.modal = {
                    isError: false,
                    textTitle: '',
                    textContent: '',
                    state: false,
                    isProcess: false
                }

                this.validationError = null;
            }

            callAction() {
                // send to children component 'copy' event
                this.$scope.$broadcast(this.action);
            }

            onSuccess(amount) {
                this.modal.isProcess = false;

                this.modal.textTitle = (this.action === this.actions.StartCopy)
                    ? this.translation.leaderIsCopied
                    : this.translation.copyActionStopped;

                this.modal.textContent = (this.action === this.actions.StartCopy)
                    ? `$${amount} copy action successfully performed. <br/> 
                        The leader ${this.trader.fullname} is now added to your portfolio.`
                    : `The leader ${this.trader.fullname} is no longer copied. <br/>
                       All copied positions are now closed`;

                this.modal.actionText = this.translation.continue;

                this.modal.back = (this.action === this.actions.StartCopy)
                    ? {
                        state: 'root.app.socialLeader',
                        params: {id: this.trader.id}
                    }
                    : {
                        state: 'root.app.social'
                    }
            }

            onFail(error) {
                this.modal.isError = true;
                this.modal.state = true;
                this.modal.isProcess = false;
                this.modal.textTitle = (this.action === this.actions.StartCopy)
                    ? this.translation.failedCopy
                    : this.translation.failedStop;
                this.modal.textContent = this.translation.messages[error.data.type] || 'Something went wrong';
                this.modal.actionText = this.translation.continue;
            }

            onActionStart() {
                this.modal.isError = false;
                this.modal.state = true;
                this.modal.isProcess = true;
                this.modal.textTitle = (this.action === this.actions.StartCopy)
                    ? this.translation.copyProcessing
                    : this.translation.stopCopyProcessing;
            }

            onValidation(error) {
                this.validationError = error;
                console.log('validation', this.validationError)
            }

            deposit() {
                return this.utils.navigate('root.app.wallet');
            }
        }

        return new LeaderCopyPage()
    }]);

